import {
  UPDATE_NOTE_LIST,
  UPDATE_DELETENOTE_LIST,
  RESET_NOTE_LIST,
  RESET_DELETENOTE_LIST,
  ADD_TOTAL,
  REDUCE_TOTAL,
  RESET_TOTAL,
  UPDATE_POSTDAY_LIST,
  RESET_POSTDAY_LIST,
  RESET_FOLLOW_NOTE_LIST,
  UPDATE_FOLLOW_NOTE_LIST,
  UPDATE_NOTIFICATION_LIST,
  RESET_NOTIFICATION_LIST,
  PIN_NOTIFICATION_LIST,
  SET_EHD_SETTING
} from '../../constant';

const NoteList = (
  State = { noteList: [], followList: [], deleteList: [], postdayList: [], notification: [], setting:[], sinkCompletedChecklist: false },
  action = {}
) => {
  const { type, data } = action;
  switch (type) {
    case UPDATE_NOTE_LIST:
      return { ...State, noteList: [...State.noteList, data.taskId] };
    case UPDATE_FOLLOW_NOTE_LIST:
      return { ...State, followList: [...State.followList, data.taskId] };
    case UPDATE_DELETENOTE_LIST:
      return { ...State, deleteList: [...State.deleteList, data.deletetaskId] };
    case UPDATE_POSTDAY_LIST:
      return { ...State, postdayList: [...State.postdayList, data.taskId] };
    case UPDATE_NOTIFICATION_LIST:
      return { ...State, notification: [...State.notification, data] };
    case RESET_NOTE_LIST:
      return { ...State, noteList: [] };
    case RESET_FOLLOW_NOTE_LIST:
      return { ...State, followList: [] };
    case RESET_DELETENOTE_LIST:
      return { ...State, deleteList: [] };
    case RESET_POSTDAY_LIST:
      return { ...State, postdayList: [] };
    case RESET_NOTIFICATION_LIST:
      return { ...State, notification: [] };
    case PIN_NOTIFICATION_LIST:
      let tempList = State.notification;
      tempList[data.index] = data.content;
      return { ...State, notification: tempList };
    default:
      return State;
  }
};

const FolowTotal = (state = 0, action = {}) => {
  const { type, data } = action;
  switch (type) {
    case ADD_TOTAL:
      return state + Number(data.num);
    case REDUCE_TOTAL:
      return state - Number(data.num);
    case RESET_TOTAL:
      return Number(data.total);
    default:
      return state;
  }
};

const ehdSetting = (state = 0, action = { setting:{}, sinkCompletedChecklist: false, isNotToSendAsDefault: false }) => {
  const { type, data } = action;
  switch (type) {
    case  SET_EHD_SETTING:
      let sinkCompletedChecklist = (data??[]).some(s => s.settingKey === "SINK_COMPLELTED_CHECKLIST_ITEM" && s.isEnable === "Y" && s.settingValue === "Y");
      let isNotToSendAsDefault = (data??[]).some(s => s.settingKey === "IS_NOT_TO_SEND_AS_DEFAULT" && s.isEnable === "Y" && s.settingValue === "Y");
      return  { ...state, 
        sinkCompletedChecklist: sinkCompletedChecklist,
        isNotToSendAsDefault: isNotToSendAsDefault,
        setting: (data??[]).filter(s => s.isEnable === "Y" ).map(s => ({
          settingKey: s.settingKey,
          settingValue: s.settingValue
      }))};
    default:
      return state;
  }
};

export { NoteList, FolowTotal, ehdSetting };
